import script from "./myDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./myDailog.vue?vue&type=script&setup=true&lang=js"

import "./myDailog.vue?vue&type=style&index=0&id=7f3d706c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3d706c"]])

export default __exports__